import {
  AddPaymentRequestsToPaymentDocument,
  PaymentsPageDocument,
} from 'generated/resources/graphql'
import moment from 'moment'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import type { SelectAllFilters } from 'modules/banking/components/PayPaymentRequestsInBulkModal'

export const useAddPaymentRequestsMutation = () => {
  const today = moment().format('YYYY-MM-DD')
  const weekStart = moment().startOf('week').format('YYYY-MM-DD')
  const weekEnd = moment().endOf('week').format('YYYY-MM-DD')
  const { company } = useCurrentSession()
  const [addPaymentRequestsBankingPayment, { loading }] = useMutation(
    AddPaymentRequestsToPaymentDocument,
    {
      extractorFn: (data) => data.bankingMutations.addPaymentRequestsBankingPayment,
      refetchQueries: [
        {
          query: PaymentsPageDocument,
          variables: {
            companyId: company.id,
            featureNames: ['dev_finance_swan_reactivation'],
            todayDate: today,
            weekRange: { from: weekStart, to: weekEnd },
          },
        },
      ],
      awaitRefetchQueries: true,
    }
  )

  const submitAddPaymentRequests = async ({
    onSuccess,
    paymentRequestIds,
    paymentId,
    selectAll,
    excludedPaymentRequestIds,
    filters,
  }: {
    onSuccess: () => void
    paymentRequestIds: string[]
    paymentId: string
    selectAll?: boolean
    excludedPaymentRequestIds?: string[]
    filters?: SelectAllFilters
  }) => {
    const result = await addPaymentRequestsBankingPayment({
      variables: {
        paymentId: paymentId,
        paymentRequestIds: selectAll ? undefined : paymentRequestIds,
        selectAll: selectAll || undefined,
        excludedPaymentRequestIds: selectAll ? excludedPaymentRequestIds : undefined,
        requesterIds: selectAll ? filters?.requesterIds : undefined,
        sourceTypes: selectAll ? filters?.sourceTypes : undefined,
        search: selectAll ? filters?.search : undefined,
        onTime: selectAll ? filters?.onTime : undefined,
        dueThisWeek: selectAll ? filters?.dueThisWeek : undefined,
        overdue: selectAll ? filters?.overdue : undefined,
        dueDateFrom: selectAll ? filters?.dueDateFrom : undefined,
        dueDateTo: selectAll ? filters?.dueDateTo : undefined,
      },
    })
    const handled = handleResult(result, () => {})
    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('banking.bulk_payment.new_bulk_payment_modal.added_payment_requests'),
      })
      onSuccess()
    } else {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('errors.generic_error'),
      })
    }
    return handled
  }

  return {
    submitAddPaymentRequests,
    loading,
  }
}
